<template>
  <div class="break-words w-screen select-none">
    <UpdateApp
      v-if="appIsOutdated && $route.name == 'Lounge' && !useOldVersion"
      @useOldVersion="useOldVersion = true"
    />
    <div
      v-else
      class="app h-screen overflow-hidden flex flex-col mx-auto sm:max-w-5xl"
    >
      <div class="guttertop"></div>
      <router-view class="flex-1 overflow-scroll"></router-view>
      <div class="gutterbottom"></div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import UpdateApp from "@/components/UpdateApp";
import { App } from "@capacitor/app";
import { Device } from "@capacitor/device";
import { Dialog } from "@capacitor/dialog";
import { Storage } from "@capacitor/storage";
import { PushNotifications } from "@capacitor/push-notifications";
import { SplashScreen } from "@capacitor/splash-screen";
import { Toast } from "@capacitor/toast";
console.log("App Started");
export default {
  components: { UpdateApp },
  created() {
    App.addListener("backButton", (event) => {
      if (this.$route.name == "Lounge" || !event.canGoBack) {
        App.exitApp();
      } else {
        window.history.back();
      }
    });
    this.setUpPushNotifications();
    App.getInfo().then((infoObject) => {
      this.presentBuild = infoObject.build;
    });
    document.addEventListener(
      "touchmove",
      (e) => {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      },
      { passive: false }
    );
  },
  mounted() {
    // Hide the splash (you should do this on app launch)
    SplashScreen.hide();
  },
  data() {
    return {
      useOldVersion: false,
      presentBuild: 999999999999,
    };
  },
  computed: {
    appIsOutdated() {
      return this.presentBuild < this.latestBuild;
    },
    latestBuild() {
      return this.$store.state.appDetails.update?.latestBuild;
    },
  },
  methods: {
    setUpPushNotifications() {
      PushNotifications.addListener("registration", (tokenObject) => {
        var newToken = tokenObject.value;
        console.log("FCM Native App token: ", newToken);
        if (this.$route.name == "Lounge")
          Toast.show({ text: "Welcome, Batter", position: "center" });
        var uid = firebase.auth().currentUser?.uid;
        if (localStorage.pendingAppTokenRegistration == "true" && uid) {
          firebase
            .firestore()
            .collection("Users")
            .doc(uid)
            .update({ fcmTokens: [newToken] })
            .then(() => {
              localStorage.removeItem("pendingAppTokenRegistration");
            });
        }
        Storage.get({ key: "fcmToken" }).then((oldTokenObject) => {
          var oldToken = oldTokenObject.value;
          if (oldToken != newToken) {
            Device.getId().then((idObject) => {
              Device.getInfo().then((infoObject) => {
                var deviceID = idObject.uuid;
                var platform = infoObject.platform || "unknown";
                firebase
                  .firestore()
                  .collection("FCMTokens")
                  .doc(deviceID)
                  .set({
                    id: deviceID,
                    platform: platform,
                    token: newToken,
                  })
                  .then(() => {
                    Storage.set({ key: "fcmToken", value: newToken });
                  });
              });
            });
          }
        });
      }).catch((error) => {
        console.error(error);
      });

      PushNotifications.addListener("registrationError", (error) => {
        console.error("Error registering Push:", error);
        if (this.$route.name == "Lounge")
          Toast.show({ text: "Welcome", position: "center" });
      });
      PushNotifications.addListener(
        "pushNotificationReceived",
        (notification) => {
          Dialog.alert({
            title: notification.title,
            message: notification.body,
          });
        }
      );

      PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (actionPerformed) => {
          Dialog.alert({
            title: actionPerformed.notification.data?.title,
            message: actionPerformed.notification.data?.body,
          });
        }
      );

      PushNotifications.requestPermissions()
        .then((result) => {
          if (result.receive == "granted") {
            PushNotifications.register();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  /* fixes safe area on ios */
  margin-right: env(safe-area-inset-right);
  margin-left: env(safe-area-inset-left);
}
.guttertop {
  height: env(safe-area-inset-top);
}
.gutterbottom {
  height: env(safe-area-inset-bottom);
}
.gutterpaddingbottom {
  padding-bottom: env(safe-area-inset-bottom);
}
.guttermarginbottom {
  margin-bottom: env(safe-area-inset-bottom);
}
.background {
  background-image: url("../src/assets/bandbdottedbackground.jpg");
  background-size: cover;
  background-position: top;
}
button:focus {
  outline: none;
}
input:focus {
  outline: none;
}
</style>
